import { render, staticRenderFns } from "./NovaLicencaModal.vue?vue&type=template&id=eb7e6480&"
import script from "./NovaLicencaModal.vue?vue&type=script&lang=js&"
export * from "./NovaLicencaModal.vue?vue&type=script&lang=js&"
import style0 from "./NovaLicencaModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports